export default __webpack_public_path__ + "static/media/power.23686141.jpg";